var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-lg-flex d-none align-items-end align-content-end justify-content-center pb-5",attrs:{"id":"lineMenu"}})
}
var staticRenderFns = []

export { render, staticRenderFns }